<template>
  <SideHeader :indexPage="true" />

  <!-- App Capsule -->
  <div style="padding-top: 55px;">

    <div class="section full">
      <img src="assets/img/sample/photo/term.jpeg" alt="image" class="imaged square w-100">
    </div>

    <div class="section full mt-2">
      <div class="section-title">قوانین و مقررات</div>
      <div class="wide-block pt-2 pb-1">
        <div class="cz_wpe_content">
          <div v-html="description"></div>
        </div>
      </div>
    </div>
  </div>
  <!-- * App Capsule -->

</template>

<script>
import SideHeader from '@/components/SideHeader.vue';
import axios from 'axios';

export default {
  name: "TermConditions",
  components: {
    SideHeader
  },
  data() {
    return {
      description: 'در حال بررسی'
    }
  },
  mounted(){
    this.getTerm();
  },
  methods: {
    getTerm() {
      axios.get("https://xpanel.s-bar.ir/api/ruleregulation/driver")
        .then((response) => {
          this.description = response.data.data.description;
        });

    }
  },
}
</script>

<style scoped></style>